import React, { FC } from "react";
import { useSelector } from "react-redux";
import { Col, Row } from 'react-styled-flexboxgrid';
import { configSelector } from '../../../../redux/selectors/system/config-selector';
import GLField from '../../../../components/form/gl-field';
import FormInput, { FormInputProps } from '../../../../components/form-input/form-input';
import { FieldConfig, Config, StateFieldConfig, AvailableFromConfig } from '../../../../types/config/config';
import FormDateField, { FormDateFieldProps } from "../../../../components/form-date-field/form-date-field";
import FormCheckbox, { FormCheckboxProps } from "../../../../components/form-checkbox/form-checkbox";
import styled from "styled-components";
import SectionHeading from "../../../../components/section-heading/section-heading";

interface Props {
    manualError: Object,
    changeHandler(values: any): void
}

export const LeasedInfo: FC<Props> = (props) => {

    const { manualError } = props;

    const config = useSelector(configSelector);
    const leasedInfoConfig = config.leasedInfo;

    if (!leasedInfoConfig || !leasedInfoConfig.show) {
        return null;
    }

    const getLeasedRent = () => {
        if (leasedInfoConfig.rentPerAnnum && leasedInfoConfig.rentPerAnnum.show) {
            return (
                <Col xs={12} sm={4} md={4} lg={4}>
                    <GLField<FormInputProps>
                        name="leasedInfo.rentPerAnnum"
                        placeholder={leasedInfoConfig.rentPerAnnum.label}
                        label={leasedInfoConfig.rentPerAnnum.label}
                        use={FormInput}
                        numericOnly={true} acceptDecimals={true}
                        error={true}
                        maxLength={300} />
                </Col>
            );
        }
        return null;
    }

    const getLeasedPrice = () => {
        if (leasedInfoConfig.leasedPrice && leasedInfoConfig.leasedPrice.show) {
            return (
                <Col xs={12} sm={4} md={4} lg={4}>
                    <GLField<FormInputProps>
                        name="leasedInfo.leasedPrice"
                        placeholder={leasedInfoConfig.leasedPrice.label}
                        label={leasedInfoConfig.leasedPrice.label}
                        use={FormInput}
                        numericOnly={true} acceptDecimals={true}
                        error={true}
                        maxLength={300} />
                </Col>
            );
        }
        return null;
    }

    const getLeasedDuration = () => {
        if (leasedInfoConfig.leasedDuration && leasedInfoConfig.leasedDuration.show) {
            return (
                <Col xs={12} sm={4} md={4} lg={4}>
                    <GLField<FormInputProps>
                        name="leasedInfo.leasedDuration"
                        placeholder={leasedInfoConfig.leasedDuration.label}
                        label={leasedInfoConfig.leasedDuration.label}
                        use={FormInput}
                        numericOnly={true} acceptDecimals={true}
                        error={true}
                        maxLength={300} />
                </Col>
            );
        }
        return null;
    }

    const getLeasedDate = () => {
        if (leasedInfoConfig.leasedDate && leasedInfoConfig.leasedDate.show) {
            const fieldConfig: AvailableFromConfig = config.leasedInfo.leasedDate;
            return (
                <Col xs={12} sm={4} md={4} lg={4}>
                    <GLField<FormDateFieldProps>
                        name="leasedInfo.leasedDate"
                        placeholder={leasedInfoConfig.leasedDate.label}
                        label={leasedInfoConfig.leasedDate.label}
                        error={true}
                        use={FormDateField}
                        {...fieldConfig} />
                </Col>
            );
        }
        return null;
    }

    const getDisplayPrice = () => {
        if (leasedInfoConfig.displayPrice && leasedInfoConfig.displayPrice.show) {
            return (
                <Col xs={12} sm={4} md={4} lg={4}>
                    <DisplayPriceContainer>
                        <GLField<FormCheckboxProps>
                            use={FormCheckbox}
                            error={true}
                            name="leasedInfo.displayPrice"
                            label={leasedInfoConfig.displayPrice.label}
                        />
                    </DisplayPriceContainer>
                </Col>
            );
        }
        return null;
    }

    const DisplayError = () => {
        let errorMessages = manualError.leasedInfo.message;
        if (!errorMessages || errorMessages.length === 0) {
            return null;
        }
        else {
            errorMessages = Array.isArray(errorMessages) ? errorMessages : [errorMessages];
        }
        return (
            <Row>
                {
                    errorMessages.map((error: string, index: number) => (
                        <Col key={index} sm={12}>
                            <ErrorText>{error}</ErrorText>
                        </Col>
                    ))
                }
            </Row>
        )
    }

    return (<>
        <Row>
            <Col id="sizes" xs={12}><SectionHeading error={manualError && manualError.leasedInfo && manualError.leasedInfo.error}>{leasedInfoConfig.header}</SectionHeading></Col>
        </Row>
        {manualError && manualError.leasedInfo && manualError.leasedInfo.error && <DisplayError />}
        <Row>
            {getLeasedRent()}
            {getLeasedPrice()}
            {getLeasedDuration()}
        </Row>
        <Row between="sm">
            {getLeasedDate()}
            {getDisplayPrice()}
        </Row>
    </>);
};

const DisplayPriceContainer = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    height: 100%;
`


const ErrorText = styled.div`
    color: ${props => (props.theme.colors ? props.theme.colors.error : 'red')}; 
`;

const StyledSubtext = styled.div`
  color: #9EA8AB;
  margin-block-start: -1em;
  font-family: "futura PT Book italic";
  font-size: 14px;
  margin-left: 0.5em;
`;